<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content>
  <agr-form [formGroup]="formGroup">
    <mat-form-field class="spacing--margin-top">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <mat-select formControlName="yearControl" placeholder="{{ 'selectYear' | translate }}" data-test="select-year">
        @for (year of years; track year) {
          <mat-option [value]="year" data-test="years-item">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="spacing--margin-bottom">
      <label>
        <strong>{{ 'phosphateLegalNorms' | translate }}</strong
        ><br />
        <button type="button" mat-stroked-button (click)="file1.click()" data-test="file1-button">
          {{ selectedFile1 ? selectedFile1.name : ('selectFile' | translate) }}
        </button>
      </label>
    </div>
    <input hidden (change)="onFileSelected(1)" #file1 type="file" accept=".csv" data-test="file1-input" />
    <div class="spacing--margin-bottom">
      <label>
        <strong>{{ 'phosphateTransitionLegalNorms' | translate }}</strong
        ><br />
        <button type="button" mat-stroked-button (click)="file2.click()" data-test="file2-button">
          {{ selectedFile2 ? selectedFile2.name : ('selectFile' | translate) }}
        </button>
      </label>
    </div>
    <input hidden (change)="onFileSelected(2)" #file2 type="file" accept=".csv" data-test="file2-input" />
  </agr-form>
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile1 || !selectedFile2 || !formGroup.get('yearControl')?.value"
    (click)="
      confirm({
        file1: selectedFile1,
        file2: selectedFile2,
        calendarYear: formGroup.get('yearControl')?.value,
      })
    "
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
